module.exports = __webpack_public_path__ + "img/content4-3.1de6e939.png";